import { render, staticRenderFns } from "./daily-office-center.vue?vue&type=template&id=8a68763a"
import script from "./daily-office-center.vue?vue&type=script&lang=js"
export * from "./daily-office-center.vue?vue&type=script&lang=js"
import style0 from "./daily-office-center.vue?vue&type=style&index=0&id=8a68763a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports